var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-landing'),_c('home-features'),_c('home-enkrypt'),_c('home-eth-blocks'),_c('home-socials'),_c('home-why-mew'),_c('mewtopia-block'),_c('partners-block'),_c('get-started')],1)}
var staticRenderFns = []

export { render, staticRenderFns }